import { Box, Button, Container, Paper, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import useExperienceData from "../../hooks/useExperienceData";
import Loading from "../other/Loading";
import Experiences from "./Experiences";
import Invitation from "./Invitation";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../store/slice/userSlice";

import BookOnlineOutlinedIcon from '@mui/icons-material/BookOnlineOutlined';
import QrCodeDialog from "./QrCodeDialog";

const ExperienceDashboard = () => {
  const theme = useTheme();
  
  const [openBoardingPass, setOpenBoardingPass] = useState(false);
  const dispatch = useDispatch();
  const {
    doneExperiences,
    experienceInvitations,
    experienceRegistrations,
    confirmationExperiences,
    loading,
    error,
  } = useExperienceData();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (error) {
      dispatch(logout());
    }
  }, [error]);
  if (loading) {
    localStorage.setItem('selectedTab', 1);
    return <Loading />;
  }

  if (
    !experienceRegistrations.length &&
    !experienceInvitations.length &&
    !confirmationExperiences.length &&
    !doneExperiences.length
  ) {
    return null;  
  }
  
  return (
    <Container
      sx={{
        "@media (max-width: 600px)": {
          padding: 1,
        },
      }}
    >
      <Box
          sx={{
            backgroundColor: "secondary.200",
            padding: {
              xs: "15px",
              sm: "20px",
            },
            borderRadius: "8px",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            marginBottom: "1em"
          }}
        >
          <Typography variant="h6" gutterBottom fontWeight={550} sx={{color: theme.palette.text.accent}}>
            Show experiment pass <Button variant="outlined" sx={{color: "white"}}onClick={() => setOpenBoardingPass(true)}><BookOnlineOutlinedIcon/> click here</Button>
          </Typography>
      </Box>
      <Box flexDirection={"column"} display={"flex"} gap={3}>
        {experienceRegistrations.length > 0 && (
          <Paper
            sx={{
              marginBottom: 2,
              padding: 3,
              boxShadow: 3,
              borderRadius: 2,
              backgroundColor: 'secondary.200',
              "@media (max-width: 600px)": {
                padding: 0,
              },
            }}
          >
            <Typography variant="h6" gutterBottom fontWeight={550} sx={{color: theme.palette.text.accent}}>
              {t("experiments_already_registered_for")}
            </Typography>
            <Experiences
              data={experienceRegistrations}
              type={"invitation confirmed"}
            />
          </Paper>
        )}

        {experienceInvitations.length > 0 && (
          <Paper
            sx={{
              marginBottom: 2,
              padding: 3,
              boxShadow: 3,
              borderRadius: 2,
              backgroundColor: 'secondary.200',
              "@media (max-width: 600px)": {
                padding: 0,
              },
            }}
          >
            <Typography variant="h6" gutterBottom fontWeight={550} sx={{color: theme.palette.text.accent}}>
              {t("experiments_you_are_invited_for")}
            </Typography>
            <Invitation data={experienceInvitations} />
          </Paper>
        )}

        {confirmationExperiences.length > 0 && (
          <Paper
            sx={{
              marginBottom: 2,
              padding: 3,
              boxShadow: 3,
              borderRadius: 2,
              backgroundColor: 'secondary.200',
              "@media (max-width: 600px)": {
                padding: 0,
              },
            }}
          >
            <Typography variant="h6" gutterBottom fontWeight={550} sx={{color: theme.palette.text.accent}}>
              {t("experiments_paid_confirmation")}
            </Typography>
            <Experiences data={confirmationExperiences} type={"payment"} />
          </Paper>
        )}

        {doneExperiences.length > 0 && (
          <Paper
            sx={{
              marginBottom: 2,
              padding: 3,
              boxShadow: 3,
              borderRadius: 2,
              backgroundColor: 'secondary.200',
            }}
          >
            <Typography fontWeight={550} variant="h6" gutterBottom sx={{color: theme.palette.text.accent}}>
              {t("experiments_you_participated")}
            </Typography>
            <Experiences data={doneExperiences} type={"done"} />
          </Paper>
        )}
      </Box>
      <Box marginBottom={5} />
      
      <QrCodeDialog open={openBoardingPass} onClose={() => setOpenBoardingPass(false)} />
    </Container>
  );
};

export default ExperienceDashboard;
